import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { TokenService } from "./token.service";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class GeneralCountService {
    apiUrl = environment.API_URL + 'internal/';

    constructor(
        private httpClient: HttpClient,
        private tokenService: TokenService
    ) { }

    getCustomerHeader() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
            'Accept-Language': 'pt-BR'
        });
    }

    public getGeneralCounts(branchCode: number, status?: string, page: number = 1, pageSize: number = 100): Observable<any> {
        let params = new HttpParams()
            .set('BranchCode', branchCode)
            .set('Page', page)
            .set('PageSize', pageSize);

        if (status !== undefined && status !== '') {
            params = params.set('CountStatus', status);
        }

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/general-counts', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public getGeneralCountItems(branchCode: number, countCode: number, page: number = 1, pageSize: number = 1000): Observable<any> {
        let params = new HttpParams()
            .set('branchCode', branchCode)
            .set('countCode', countCode)
            .set('page', page)
            .set('pageSize', pageSize);

        return this.httpClient.get<any>(this.apiUrl + 'product-count/v2/general-count-items', {
            params: params,
            headers: this.getCustomerHeader()
        });
    }

    public postGeneralCount(branchCode: number, description: string): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "description": description,
            "component": "GERAPP004"
        };

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/counts', data, { headers: this.getCustomerHeader() });
    }

    public postGeneralCountItem(branchCode: number, countCode: number, productCode: string, barCode: string, quantity: number): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "code": countCode,
            "productCode": productCode,
            "barCode": barCode,
            "quantity": quantity
        };

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/counts-item', data, { headers: this.getCustomerHeader() });
    }

    public deleteGeneralCountItem(branchCode: number, countCode: number, productCode: number, rfid: string): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "countCode": countCode,
            "items": [
                {
                    "productCode": productCode
                }
            ]
        };

        return this.httpClient.delete<any>(this.apiUrl + 'product-count/v2/itens-count', {
            body: data,
            headers: this.getCustomerHeader()
        });
    }

    public postGeneralCountStatus(branchCode: number, countCode: number, status: number): Observable<any> {
        let data = {
            "branchCode": branchCode,
            "code": countCode,
            "Status": status
        };

        return this.httpClient.post<any>(this.apiUrl + 'product-count/v2/counts-status', data, { headers: this.getCustomerHeader() });
    }

    public getProduct(BarCode: string, BranchCode: number): Observable<any> {
        return this.httpClient.get<any>(this.apiUrl + 'product/v2/products/' + BarCode + '/' + BranchCode, { headers: this.getCustomerHeader() });
    }
}
